import React from 'react'
import { Box, FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup, Typography } from '@mui/material'

import { HousingTypeStepProps } from '../types'

const HousingTypeStep: React.FC<HousingTypeStepProps> = ({ value, onChange, error }) => {
  const options = ['Studio / 1-bed', '2-3 Bedroom', '4+ Bedroom', 'Flexible / No sure yet']

  return (
    <Box className="flex flex-col gap-6">
      <Typography variant="h5" className="font-bold text-gray-900">
        What floor plan are you most interested in?
      </Typography>

      <FormControl error={error}>
        <RadioGroup value={value} onChange={e => onChange(e.target.value)} className="flex flex-col gap-2">
          {options.map(opt => (
            <FormControlLabel key={opt} value={opt} control={<Radio />} label={opt} className="text-base" />
          ))}
        </RadioGroup>
        {error && <FormHelperText>This question is required</FormHelperText>}
      </FormControl>
    </Box>
  )
}

export default HousingTypeStep
